import React from "react";
import { Badge, Box, Typography } from "@mui/material";
import "./overlayText.scss";
import { mergeOverlayStyle } from "../../utils/HelperFunctions";
import { DEFAULT_OVERLAY_CSS } from "../../utils/cssConstants";

interface OverlayTextProps {
  leftSideTextOverlay: string;
  rightSideTextOverlay: string;
  overlayCss: any;
}

const OverlayText: React.FC<OverlayTextProps> = ({
  leftSideTextOverlay,
  rightSideTextOverlay,
  overlayCss
}) => {
  const rightOverlayWords =
    rightSideTextOverlay?.trim().split(" ").filter(Boolean) ?? [];
  const leftContainerStyles = mergeOverlayStyle(
    DEFAULT_OVERLAY_CSS.leftOverlay.containerStyle,
    overlayCss?.leftOverlay?.containerStyle ?? {}
  );
  const rightContainerStyles = mergeOverlayStyle(
    DEFAULT_OVERLAY_CSS.rightOverlay.containerStyle,
    overlayCss?.rightOverlay?.containerStyle ?? {}
  );
  const leftTextStyles = mergeOverlayStyle(
    DEFAULT_OVERLAY_CSS.leftOverlay.textStyle,
    overlayCss?.leftOverlay?.textStyle ?? {}
  );
  const rightTextStyles = mergeOverlayStyle(
    DEFAULT_OVERLAY_CSS.rightOverlay.textStyle,
    overlayCss?.rightOverlay?.textStyle ?? {}
  );

  return (
    <Box className="overlayTextContainer" >
      {/* Top Left Badge */}
      {leftSideTextOverlay && (
        <Badge
          className={`topLeftBadge ${leftContainerStyles?.right ? "leftOvRadiusRight": "leftOvRadiusLeft"}`}
          sx={{
            ...leftContainerStyles,
            zIndex: 10,
          }}
        >
          <Box className="badgeText">
            <Typography
              className="dateText"
              sx={{
                ...leftTextStyles,
              }}
            >
              {leftSideTextOverlay}
            </Typography>
          </Box>
        </Badge>
      )}

      {/* Top Right Badge */}
      {rightOverlayWords.length > 0 && (
        <Badge
          
          className={`topRightBadge ${rightContainerStyles?.bottom ? "rightOvRadiusBottom": "rightOvRadiusTop"}`}
          sx={{
            ...rightContainerStyles,
            zIndex: 10,
          }}
        >
          <Box className="badgeText">
            {rightOverlayWords.map((word, id) => (
              <Typography
                key={word}
                className="dateText"
                sx={{
                  ...(id === 0
                    ? {
                        fontWeight: "900",
                        fontSize: "20px",
                        textShadow: "0 0 1px currentColor",
                      }
                    : null),
                  ...rightTextStyles,
                }}
              >
                {word}
              </Typography>
            ))}
          </Box>
        </Badge>
      )}
    </Box>
  );
};

export default OverlayText;
